// src/pages/News.js
import React, { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import { useTranslation } from "react-i18next";
import rehypeRaw from "rehype-raw";
import "../styles/pages/News.css";

export default function News() {
  const { t } = useTranslation();
  const [md, setMd] = useState("");

  useEffect(() => {
    fetch(process.env.PUBLIC_URL + "/data/news/News.md")
      .then(r => r.text())
      .then(setMd)
      .catch(e => console.error("News.md load error:", e));
  }, []);

  return (
    <div className="fishipedia-page news-page">

      

      <h1>{t("news_title")}</h1>
      <p style={{ color: "#555" }}>
        {t("news_intro")}
      </p>

      <ReactMarkdown
  rehypePlugins={[rehypeRaw]}
  components={{
    img: ({ alt, ...props }) => (
      <img
        {...props}
        alt={alt || t("news_image_alt", { defaultValue: "News image" })}
        style={{
          maxWidth: "100%",
          borderRadius: "10px",
          margin: "14px 0",
          boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
        }}
      />
    ),
    a: ({ children, href, ...props }) => (
      <a
        {...props}
        href={href}
        style={{
          display: "inline-block",
          background: "#1fa4c5",
          color: "#fff",
          padding: "8px 14px",
          borderRadius: "6px",
          textDecoration: "none",
          marginTop: "8px",
          boxShadow: "0 3px 6px rgba(0,0,0,0.2)",
        }}
        target="_blank"
        rel="noopener noreferrer"
      >
        {children || href}
      </a>
    ),
  }}
>
  {md || t("news_loading")}
</ReactMarkdown>

    </div>
  );
}
